import product_1 from "../assets/images/product-1.jpg";
import product_1_1 from "../assets/images/product-1-1.jpg";
import product_1_2 from "../assets/images/product-1-2.jpg";
import product_1_3 from "../assets/images/product-1-3.jpg";
import product_1_4 from "../assets/images/product-1-4.jpg";
import product_2 from "../assets/images/product-2.jpg";
import product_2_1 from "../assets/images/product-2-1.jpg";
import product_2_2 from "../assets/images/product-2-2.jpg";
import product_2_3 from "../assets/images/product-2-3.jpg";
import product_2_4 from "../assets/images/product-2-4.jpg";
import product_3 from "../assets/images/product-3.jpg";
import product_3_1 from "../assets/images/product-3-1.jpg";
import product_3_2 from "../assets/images/product-3-2.jpg";
import product_3_3 from "../assets/images/product-3-3.jpg";
import product_3_4 from "../assets/images/product-3-4.jpg";
import product_4 from "../assets/images/product-4.jpg";
import product_4_1 from "../assets/images/product-4-1.jpg";
import product_4_2 from "../assets/images/product-4-2.jpg";
import product_4_3 from "../assets/images/product-4-3.jpg";
import product_4_4 from "../assets/images/product-4-4.jpg";
import product_5 from "../assets/images/product-5.jpg";
import product_5_1 from "../assets/images/product-5-1.jpg";
import product_5_2 from "../assets/images/product-5-2.jpg";
import product_5_3 from "../assets/images/product-5-3.jpg";
import product_5_4 from "../assets/images/product-5-4.jpg";

let products = [
  {
    id: "80d8e7a1",
    name: "торговий павільйон",
    stock: 2,
    featured: true,
    price: 32000000,
    image: product_1,
    images: [
      {
        id: "attub6EG88kJKuYs8",
        width: 1000,
        height: 667,
        url: product_1,
        filename: "product-4.jpeg",
        size: 49641,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_1,
            width: 54,
            height: 36,
          },
          large: {
            url: product_1,
            width: 768,
            height: 512,
          },
          full: {
            url: product_1,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attaeT2Dex98o2jfW",
        width: 1000,
        height: 667,
        url: product_1_1,
        filename: "extra-1.jpeg",
        size: 102108,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_1_1,
            width: 54,
            height: 36,
          },
          large: {
            url: product_1_1,
            width: 768,
            height: 512,
          },
          full: {
            url: product_1_1,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attWsZasaaRD1P7mm",
        width: 1000,
        height: 714,
        url: product_1_2,
        filename: "extra-2.jpeg",
        size: 84418,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_1_2,
            width: 50,
            height: 36,
          },
          large: {
            url: product_1_2,
            width: 717,
            height: 512,
          },
          full: {
            url: product_1_2,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attTvaiDcADaAItLw",
        width: 1000,
        height: 650,
        url: product_1_3,
        filename: "extra-3.jpeg",
        size: 107838,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_1_3,
            width: 55,
            height: 36,
          },
          large: {
            url: product_1_3,
            width: 788,
            height: 512,
          },
          full: {
            url: product_1_3,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attdxQmF0aCH5I32F",
        width: 1000,
        height: 667,
        url: product_1_4,
        filename: "extra-4.jpeg",
        size: 99481,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_1_4,
            width: 54,
            height: 36,
          },
          large: {
            url: product_1_4,
            width: 768,
            height: 512,
          },
          full: {
            url: product_1_4,
            width: 3000,
            height: 3000,
          },
        },
      },
    ],
    reviews: 27,
    stars: 4.2,
    colors: ["#ff0000", "#00ff00", "#0000ff"],
    company: "comfy maf",
    description:
      "Торговий павільйон 7×5,каркас виконаний з металевої труби 80×40,50×50.Підлога-оцинковка, дошка обрізна, оброблена, утеплювач пінополістирол, плита ОСБ 10 мм, лінолеум.Стіни утеплені кам'яною ватою, зовні профлист з комбінованою кольоровою гамою, великі металопластикові вікна, панорамні, з середини стіни та дах - пластикова вагонка; повністю оснащений електрикою (8 подвійних розеток, вимикачі, 4 світильники, коробка з автоматами). Двоє дверей, вхідні металопластикові, скляні, а також металічні утеплені. Можна використовувати дану споруд і як офіс, за бажанням можливе установлення кондиціонера, санвузла.",
    category: "office",
    shipping: true,
  },
  {
    id: "80d8e777",
    name: "дачний будинок",
    stock: 2,
    featured: true,
    price: 28000000,
    image: product_2,
    images: [
      {
        id: "attub6EG88kJKuYs8",
        width: 1000,
        height: 667,
        url: product_2,
        filename: "product-4.jpeg",
        size: 49641,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_2,
            width: 54,
            height: 36,
          },
          large: {
            url: product_2,
            width: 768,
            height: 512,
          },
          full: {
            url: product_2_1,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attaeT2Dex98o2jfW",
        width: 1000,
        height: 667,
        url: product_2_1,
        filename: "extra-1.jpeg",
        size: 102108,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_2_1,
            width: 54,
            height: 36,
          },
          large: {
            url: product_2_1,
            width: 768,
            height: 512,
          },
          full: {
            url: product_2_1,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attWsZasaaRD1P7mm",
        width: 1000,
        height: 714,
        url: product_2_2,
        filename: "extra-2.jpeg",
        size: 84418,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_2_2,
            width: 50,
            height: 36,
          },
          large: {
            url: product_2_2,
            width: 717,
            height: 512,
          },
          full: {
            url: product_2_2,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attTvaiDcADaAItLw",
        width: 1000,
        height: 650,
        url: product_2_3,
        filename: "extra-3.jpeg",
        size: 107838,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_2_3,
            width: 55,
            height: 36,
          },
          large: {
            url: product_2_3,
            width: 788,
            height: 512,
          },
          full: {
            url: product_2_3,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attdxQmF0aCH5I32F",
        width: 1000,
        height: 667,
        url: product_2_4,
        filename: "extra-4.jpeg",
        size: 99481,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_2_4,
            width: 54,
            height: 36,
          },
          large: {
            url: product_2_4,
            width: 768,
            height: 512,
          },
          full: {
            url: product_2_4,
            width: 3000,
            height: 3000,
          },
        },
      },
    ],
    reviews: 27,
    stars: 4.2,
    colors: ["#ff0000", "#00ff00", "#0000ff"],
    company: "comfy maf",
    description:
      "Дачний будинок 7×3, каркас виготовлений з металевої труби 80×40,50×50; утеплений кам'яною ватою 100 мм, вологозахисна мембрана, стіни та стеля-ОСБ 10 мм, зовні металевий блок-хаус, дах - металочерепиця. Підлога - оцинковка, дошка, пінополістирол, плита ОСБ 10 мм, лінолеум. Двері вхідні-металеві, утеплені, 2 замки, вікна металопластикові-2шт. Будиночок повністю оснащений електрикою (розетки, вимикачі, світильники) можливе встановлення санвузла, кондиціонера, решіток, жалюзі та ін.елементів побуту за бажанням замовника. Використовувати дану споруду можливо, як дачний будиночок, а також як офісне приміщення.",
    category: "office",
    shipping: true,
  },
  {
    id: "80d8e3у3",
    name: "пост охорони",
    stock: 2,
    featured: true,
    price: 7500000,
    image: product_3,
    images: [
      {
        id: "attub6EG88kJKuYs8",
        width: 1000,
        height: 667,
        url: product_3,
        filename: "product-4.jpeg",
        size: 49641,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_3,
            width: 54,
            height: 36,
          },
          large: {
            url: product_3,
            width: 768,
            height: 512,
          },
          full: {
            url: product_3,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attaeT2Dex98o2jfW",
        width: 1000,
        height: 667,
        url: product_3_1,
        filename: "extra-1.jpeg",
        size: 102108,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_3_1,
            width: 54,
            height: 36,
          },
          large: {
            url: product_3_1,
            width: 768,
            height: 512,
          },
          full: {
            url: product_3_1,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attWsZasaaRD1P7mm",
        width: 1000,
        height: 714,
        url: product_3_2,
        filename: "extra-2.jpeg",
        size: 84418,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_3_2,
            width: 50,
            height: 36,
          },
          large: {
            url: product_3_2,
            width: 717,
            height: 512,
          },
          full: {
            url: product_3_2,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attTvaiDcADaAItLw",
        width: 1000,
        height: 650,
        url: product_3_3,
        filename: "extra-3.jpeg",
        size: 107838,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_3_3,
            width: 55,
            height: 36,
          },
          large: {
            url: product_3_3,
            width: 788,
            height: 512,
          },
          full: {
            url: product_3_3,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attdxQmF0aCH5I32F",
        width: 1000,
        height: 667,
        url: product_3_4,
        filename: "extra-4.jpeg",
        size: 99481,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_3_4,
            width: 54,
            height: 36,
          },
          large: {
            url: product_3_4,
            width: 768,
            height: 512,
          },
          full: {
            url: product_3_4,
            width: 3000,
            height: 3000,
          },
        },
      },
    ],
    reviews: 27,
    stars: 4.2,
    colors: ["#ff0000", "#00ff00", "#0000ff"],
    company: "comfy maf",
    description:
      "Пост охорони 2×2. Каркас з металевої труби 80×40,50×50;утеплений мін.ватою 100 мм, вологозахисна мембрана, з середини стіни ОСБ 10 мм, зовні профлист, підлога оцинкована, дошка, утеплювач, лінолеум. Має три металопластикові вікна і двері зі склом, що робить оглядовим з усіх сторін, оснащений електрикою. Даний об'єкт, можна використовувати для охорони; в побутових цілях садових товариств, на будівництві, пунктах пропуску та ін.",
    category: "office",
    shipping: true,
  },
  {
    id: "80d8e223",
    name: "будівельний вагончик 4х2.5",
    stock: 2,
    featured: true,
    price: 11500000,
    image: product_4,
    images: [
      {
        id: "attub6EG88kJKuYs8",
        width: 1000,
        height: 667,
        url: product_4,
        filename: "product-4.jpeg",
        size: 49641,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_4,
            width: 54,
            height: 36,
          },
          large: {
            url: product_4,
            width: 768,
            height: 512,
          },
          full: {
            url: product_4,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attaeT2Dex98o2jfW",
        width: 1000,
        height: 667,
        url: product_4_1,
        filename: "extra-1.jpeg",
        size: 102108,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_4_1,
            width: 54,
            height: 36,
          },
          large: {
            url: product_4_1,
            width: 768,
            height: 512,
          },
          full: {
            url: product_4_1,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attWsZasaaRD1P7mm",
        width: 1000,
        height: 714,
        url: product_4_2,
        filename: "extra-2.jpeg",
        size: 84418,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_4_2,
            width: 50,
            height: 36,
          },
          large: {
            url: product_4_2,
            width: 717,
            height: 512,
          },
          full: {
            url: product_4_2,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attTvaiDcADaAItLw",
        width: 1000,
        height: 650,
        url: product_4_3,
        filename: "extra-3.jpeg",
        size: 107838,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_4_3,
            width: 55,
            height: 36,
          },
          large: {
            url: product_4_3,
            width: 788,
            height: 512,
          },
          full: {
            url: product_4_3,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attdxQmF0aCH5I32F",
        width: 1000,
        height: 667,
        url: product_4_4,
        filename: "extra-4.jpeg",
        size: 99481,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_4_4,
            width: 54,
            height: 36,
          },
          large: {
            url: product_4_4,
            width: 768,
            height: 512,
          },
          full: {
            url: product_4_4,
            width: 3000,
            height: 3000,
          },
        },
      },
    ],
    reviews: 27,
    stars: 4.2,
    colors: ["#ff0000", "#00ff00", "#0000ff"],
    company: "comfy maf",
    description:
      "Будівельний вагончик 4х2,5. Каркас виготовлений з металевої труби (80*80;50*50). Утеплений мінеральною ватою 100 мм, із застосуванням вологозахисних мембран; стіни та стеля з середини плита ОСБ 10 мм, зовні стіни та дах - профлист 0,45 мм; підлога оцинкована, дошка обрізна, пінополістирол, плита ОСБ 10 мм, лінолеум. Двері вхідні металеві, утеплені з замком, вікна металопластикові - 2 шт. Вагончик обладнаний електрикою(провід, розетки, вимикачі, світильники). За вашим бажанням можлива установка санвузла, кондиціонера, обігрівальних приладів та ін.",
    category: "office",
    shipping: true,
  },
  {
    id: "80d8e625",
    name: "будівельний вагончик 6х2.5",
    stock: 2,
    featured: true,
    price: 13900000,
    image: product_5,
    images: [
      {
        id: "attub6EG88kJKuYs8",
        width: 1000,
        height: 667,
        url: product_5,
        filename: "product-4.jpeg",
        size: 49641,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_5,
            width: 54,
            height: 36,
          },
          large: {
            url: product_5,
            width: 768,
            height: 512,
          },
          full: {
            url: product_5,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attaeT2Dex98o2jfW",
        width: 1000,
        height: 667,
        url: product_5_1,
        filename: "extra-1.jpeg",
        size: 102108,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_5_1,
            width: 54,
            height: 36,
          },
          large: {
            url: product_5_1,
            width: 768,
            height: 512,
          },
          full: {
            url: product_5_1,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attWsZasaaRD1P7mm",
        width: 1000,
        height: 714,
        url: product_5_2,
        filename: "extra-2.jpeg",
        size: 84418,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_5_2,
            width: 50,
            height: 36,
          },
          large: {
            url: product_5_2,
            width: 717,
            height: 512,
          },
          full: {
            url: product_5_2,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attTvaiDcADaAItLw",
        width: 1000,
        height: 650,
        url: product_5_3,
        filename: "extra-3.jpeg",
        size: 107838,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_5_3,
            width: 55,
            height: 36,
          },
          large: {
            url: product_5_3,
            width: 788,
            height: 512,
          },
          full: {
            url: product_5_3,
            width: 3000,
            height: 3000,
          },
        },
      },
      {
        id: "attdxQmF0aCH5I32F",
        width: 1000,
        height: 667,
        url: product_5_4,
        filename: "extra-4.jpeg",
        size: 99481,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url: product_5_4,
            width: 54,
            height: 36,
          },
          large: {
            url: product_5_4,
            width: 768,
            height: 512,
          },
          full: {
            url: product_5_4,
            width: 3000,
            height: 3000,
          },
        },
      },
    ],
    reviews: 27,
    stars: 4.2,
    colors: ["#ff0000", "#00ff00", "#0000ff"],
    company: "comfy maf",
    description:
      "Будівельний вагончик 6х2,5. Каркас виготовлений з металевої труби (80*80;50*50). Утеплений мінеральною ватою 100 мм, із застосуванням вологозахисних мембран; стіни та стеля з середини плита ОСБ 10 мм, зовні стіни та дах - профлист 0,45 мм; підлога оцинкована, дошка обрізна, пінополістирол, плита ОСБ 10 мм, лінолеум.Двері вхідні металеві, утеплені з замком, вікна металопластикові - 2 шт. Вагончик обладнаний електрикою (провід, розетки, вимикачі, світильники). За вашим бажанням можлива установка санвузла, кондиціонера, обігрівальних приладів та ін.",
    category: "office",
    shipping: true,
  },
];

export default products;
